import { css } from '@emotion/core';
// import { typography, fontWeights } from '../../../../styles/typography';
// import { colorsPalette } from '../../../../styles/colors';
// import { MediaQueries } from '../../../../styles/Grid';
// import { errorCss } from '../../../ui/Form/baseStyles/index.styles';

export const container = css({ minHeight: '56px', padding: '12px 16px' });

export const formInputHolder = css({
  '.inputfield': {},
});
export const phoneNumberFieldCssProps = {};

export const TypeAheadDropDown = css({
  position: 'relative',
  margin: '0 0 16px',

  '.typeHeadeInput-holder': {
    div: {
      height: '56px',
      padding: '9px 16px 9px',
      input: {
        fontSize: '16px',
        paddingRight: '25px',
      },
    },
  },

  // '.typeHeadeInput-holder1': {
  //   span: {
  //     fontSize: '16px',
  //   },
  //   '#undefined-helper-text': {
  //     fontSize: '14px',
  //   },
  //   label: {
  //     color: '#888888',
  //   },
  //   div: {
  //     height: 'auto',
  //     borderRadius: '4px',
  //     input: {
  //       fontSize: '16px',
  //     },
  //   },
  // },

  // label: {
  //   fontSize: '16px',
  //   color: '#393939',
  // },

  ul: {
    border: '1px solid #D9DBDD',
    position: 'absolute',
    zIndex: 1,
    background: '#fff',
    top: '56px',
    width: '100%',
    maxHeight: '350px',
    overflow: 'auto',

    li: {
      paddingTop: '10px',
      paddingBottom: '10PX',
      borderBottom: '1px solid #D9DBDD',
      cursor: 'pointer',
      display: 'flex',
      fontSize: '18px',
      lineHeight: '32px',
      paddingLeft: '5px',
      paddingRight: '15px',
      marginLeft: '15px',
      marginRight: '15px',

      i: {
        paddingRight: '22px',
      },
    },
  },
  '.TypeAheadDropDown input': {},
  '.TypeAheadDropDown ul::before': { content: "''" },
  '.TypeAheadDropDown ul': {
    listStyleType: 'none',
    textAlign: 'left',
    margin: '0',
    padding: '0',
  },

  '.TypeAheadDropDown li': { padding: '10px 5px', cursor: 'pointer' },
  '.TypeAheadDropDown li:hover': {
    background: 'lightgray',
    textDecoration: 'underline',
  },
  '.App': { margin: '150px auto 0 auto', width: '600px' },
});

export const inputValue = css({
  '&[data-shrink="true"]': {
    display: 'none',
  },
});
